/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/
/* eslint prefer-const: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */

import isNil from "lodash-es/isNil";
import { z } from "zod";

import Utility from "./utility";

class EnvironmentsStatic {
	private static _instance: EnvironmentsStatic | null = null;
	private _values: Record<string, any> = {};

	constructor() {
		this.setValues(process.env);
	}

	public static get instance() {
		if (!EnvironmentsStatic._instance) {
			EnvironmentsStatic._instance = new EnvironmentsStatic();
		}
		return EnvironmentsStatic._instance;
	}

	public get values() {
		return this._values;
	}
	private setValues(env: any) {
		for (let [key, value] of Object.entries(env)) {
			try {
				if (value) {
					this._values[key] = value;
				}
			} catch {
				this._values[key] = value;
			}
		}
	}

	private envByValue<T>(key: string, defValue: T) {
		const reactAppResult = this.values[`REACT_APP_${key}`];
		const result = this.values[key];
		if (!isNil(reactAppResult)) {
			return Utility.convert.stringToJSON<T>(reactAppResult) as T;
		}
		if (!isNil(this.values[key])) {
			return Utility.convert.stringToJSON<T>(result) as T;
		}
		return defValue as T;
	}

	public env<T>(key: string, defValue: any = null) {
		const result = isNil(this.envByValue(key, defValue))
			? process.env[`REACT_APP_${key}`]
			: this.envByValue<T>(key, defValue);
		return result as T;
	}

	public get devAccountIndex() {
		return z.coerce.number().parse(this.env("AccountIndex", 0));
	}

	public devAccountInfo(index: number) {
		const accounts = this.env<string[]>("Accounts");
		if (accounts.length < 0 || accounts.length > index) {
			return accounts[index];
		}
		return null;
	}
}

export default EnvironmentsStatic.instance;
